import { CacheProvider } from "@emotion/react";
import { FormControl, InputLabel, MenuItem, Select, ThemeProvider, createTheme } from "@mui/material";
import createCache from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';
import { prefixer } from 'stylis';
import { useState } from "react";

const RtlMui = ({ children }) => {

    const cacheRtl = createCache({
        key: 'muirtl',
        stylisPlugins: [prefixer, rtlPlugin],
    });

    const theme = createTheme({
        direction: 'rtl',
    });

    return (
        <CacheProvider value={cacheRtl}>
            <ThemeProvider theme={theme}>
                {children}
            </ThemeProvider>
        </CacheProvider>

    )
}


const SelectMui = ({ handleChange, title, defaultValue, optins, setState, filterName, state }) => {

    const cacheRtl = createCache({
        key: 'muirtl',
        stylisPlugins: [prefixer, rtlPlugin],
    });
    const theme = createTheme({
        direction: 'rtl',
    });

    const [value, setValue] = useState();
    const handleChangeCountry = (event) => {
        setValue(event.target.value);
        setState && setState({ ...state, [filterName]: event.target.value })
    };

    return (
        <CacheProvider value={cacheRtl}>
            <ThemeProvider theme={theme}>

                <FormControl variant="filled" style={{ width: "100%" }}>
                    {title && <InputLabel id="demo-simple-select-filled-label">{title}</InputLabel>}
                    <Select value={value} onChange={e => handleChangeCountry(e)} fullWidth className="slFilter">
                        {optins
                            ? optins.map(item => (
                                <MenuItem value={item.val}>{item.name}</MenuItem>
                            ))
                            : <MenuItem value={"..."}>...</MenuItem>
                        }
                    </Select>
                </FormControl>

            </ThemeProvider>
        </CacheProvider>

    )
}

export { RtlMui, SelectMui }